const ONVIF_PROFILES_ENDPOINT =
  "https://2owz15gkce.execute-api.us-east-1.amazonaws.com/default/qumra-onvif-get-profiles";

const INSTALL_MARKER = "__qumraOnvifDiscoveryFetchInstalled";

type MarkedWindow = Window & {
  [INSTALL_MARKER]?: boolean;
};

function requestUrl(input: RequestInfo | URL) {
  if (typeof input === "string") return input;
  if (input instanceof URL) return input.toString();
  return input.url;
}

/**
 * Enables extended ONVIF service discovery for every profile request.
 *
 * Some cameras expose their Media service on a different ONVIF path or port
 * than the initially configured device-service endpoint. The existing Lambda
 * already supports `extendedDiscovery`; this compatibility layer enables it
 * for both the Camera Settings page and the Quality panel.
 */
export function installOnvifDiscoveryFetch() {
  if (typeof window === "undefined") return;

  const markedWindow = window as MarkedWindow;
  if (markedWindow[INSTALL_MARKER]) return;

  const originalFetch = window.fetch.bind(window);

  window.fetch = async (input: RequestInfo | URL, init?: RequestInit) => {
    const url = requestUrl(input);
    const method = String(init?.method || "GET").toUpperCase();

    if (
      url === ONVIF_PROFILES_ENDPOINT &&
      method === "POST" &&
      typeof init?.body === "string"
    ) {
      try {
        const payload = JSON.parse(init.body);
        if (payload && typeof payload === "object" && !Array.isArray(payload)) {
          return originalFetch(input, {
            ...init,
            body: JSON.stringify({
              ...payload,
              extendedDiscovery: true,
            }),
          });
        }
      } catch {
        // Preserve the original request when the body is not valid JSON.
      }
    }

    return originalFetch(input, init);
  };

  markedWindow[INSTALL_MARKER] = true;
}
